import { safeJSONParse } from "core/model/utils/strings";
import { AuctionForm, DocsFormName, DocsSubmittedFormData } from "core/types";
import { convertEncryptedFieldIn } from "react-forms-state/src/FormUtils";
import { FORM_NAME_TO_FILE_TYPE } from "../../utils";

export const getDischargeLetterForm = ({
  formName,
  forms,
}: {
  formName: DocsFormName;
  forms: AuctionForm[];
}) => {
  const form = formName
    ? forms?.find((form) => form.form_type === FORM_NAME_TO_FILE_TYPE[formName])
    : undefined;

  const stringified = form
    ? convertEncryptedFieldIn(form.form_data as AnyObject)
    : undefined;

  const [_, parsedFormData] =
    safeJSONParse<DocsSubmittedFormData<typeof formName>>(stringified);

  return {
    form,
    formData: parsedFormData?.values,
    metadata: form?.metadata,
  };
};
